module.exports = __webpack_public_path__ + "media/audio5.827737cb.mp3";